import request from '@/common/request'
import { DetalhesDoPagamento, FormPagamento, FormaDePagamento, MenuAdministrativoSitef, Pagamento, PagamentoLinkAsaasResponse, TipoDePagamento } from '@/models'

const basePath = '/pagamentos'

export const efetuarPagamentoTef = (pdvId: string, pagamento: FormPagamento, identificadorDaVenda: string): Promise<DetalhesDoPagamento> =>
	request.post(`${basePath}/${pdvId}/controlpay`, { ...pagamento, identificadorDaVenda: identificadorDaVenda})

export const consultarPagamentoTef = (pdvId: string, detalhesDoPagamentoId: string): Promise<DetalhesDoPagamento> =>
	request.get(`${basePath}/${pdvId}/controlpay/detalhes?detalhesDoPagamentoId=${detalhesDoPagamentoId}`)

export const cancelarPagamentoTef = (pdvId: string, detalhesDoPagamentoId: string): Promise<DetalhesDoPagamento> =>
	request.post(`${basePath}/${pdvId}/controlpay/cancelar?detalhesDoPagamentoId=${detalhesDoPagamentoId}`)

export const buscarDetalhesDoPagamento = (detalhesDoPagamentoId: string): Promise<DetalhesDoPagamento> =>
	request.get(`${basePath}/detalhes/${detalhesDoPagamentoId}`)

export const consultarUltimoPagamentoTefPelaVenda = (identificadorDaVenda: string): Promise<DetalhesDoPagamento> =>
	request.get(`${basePath}/detalhes/pendente/${identificadorDaVenda}`)

export const buscarTipoDePagamentoPorForma = (formaDePagamento: FormaDePagamento, lojaId: string): Promise<TipoDePagamento[]> =>
	request.get(`${basePath}/${lojaId}/tipo-pagamento?formaDePagamento=${formaDePagamento}`)

export const salvarPagamento = (pagamento: Pagamento): Promise<void> =>
	request.post(`${basePath}/editar`, pagamento)

export const podeAlterarQtdDeParcelas = (pagamentoId: string): Promise<boolean> =>
	request.get(`${basePath}/${pagamentoId}`)

export const findPagamentosDetalhadosByVendaId = (vendaId: string): Promise<Pagamento[]> =>
	request.get(`${basePath}/venda/${vendaId}`)

export const gerarLinkDePagamentoAsaas = (lojaId: string, valor: number, nomePdv: string, parcelas: number): Promise<PagamentoLinkAsaasResponse> =>
	request.post(`${basePath}/link/asaas/${lojaId}?valor=${valor}&nomePdv=${nomePdv}&parcelas=${parcelas}`)

export const enviarLinkPagamentoAsaasPorWhatsapp = (lojaId: string, numeroCliente: string, nomeCliente: string, linkPagamento: string): Promise<void> =>
	request.post(`${basePath}/enviar-link/${lojaId}?numeroCliente=${numeroCliente}&nomeCliente=${nomeCliente}&linkPagamento=${linkPagamento}`)

export const efetuarPagamentoSitef = (pdvId: string, pagamento: FormPagamento, identificadorDaVenda: string): Promise<DetalhesDoPagamento> =>
	request.post(`${basePath}/${pdvId}/sitef`, { ...pagamento, identificadorDaVenda: identificadorDaVenda})

export const cancelarPagamentoSitef = (pdvId: string, pagamento: Pagamento): Promise<DetalhesDoPagamento> =>
	request.post(`${basePath}/${pdvId}/sitef/cancelar`, pagamento)

export const cancelarTransacaoSitefAtual = (pdvId: string, cancelado: boolean): Promise<string> =>
	request.post(`${basePath}/${pdvId}/sitef/transacao/cancelar?cancelado=${cancelado}`)

export const iniciarMenuAdministrativoSitef = (pdvId: string): Promise<string> =>
	request.post(`${basePath}/${pdvId}/sitef/menu-administrativo`)

export const buscarRetornoMenuAdministrativoSitef = (transacaoId: string): Promise<MenuAdministrativoSitef> =>
	request.get(`${basePath}/${transacaoId}/sitef/retorno-menu`)

export const salvarRetornoNoMenuAdministrativoSitef = (menuAdministrativoId: string, retorno: string): Promise<void> =>
	request.post(`${basePath}/${menuAdministrativoId}/sitef/retornar?retorno=${retorno}` )

export const finalizarMenuAdministrativoSitef = (transacaoId: string): Promise<void> =>
	request.post(`${basePath}/sitef/finalizar-menu/${transacaoId}`)

export const findProcessoSitefProcessandoByTerminal = (pdvTerminalId: string, lojaTerminalId: string): Promise<boolean> =>
	request.get(`${basePath}/sitef/busca-processo/${pdvTerminalId}/${lojaTerminalId}`)